import React from 'react';

import { createStyles, ExpansionPanelSummary, Theme, withStyles, WithStyles } from '@material-ui/core';
import MuiExpansionPanel, { ExpansionPanelProps as MuiExpansionPanelProps } from '@material-ui/core/ExpansionPanel';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import classnames from 'classnames';

import Typography from './Typography';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    panelExpanded: {
      margin: 0,
    },
    panelSummaryRoot: {
      minHeight: '0 !important',
      height: 40,
      padding: `0 ${unit * 2}px`,
    },
    panelSummaryContent: {
      margin: '12px 0 !important',
    },
    colorSupportPowder: {
      background: lighten(colorSupportPowder, 0.38),
      border: `1px solid ${colorSupportPowder}`,
    },
  });

export interface ExpansionPanelProps extends Omit<MuiExpansionPanelProps, 'classes'>, WithStyles<typeof styles> {
  color?: 'supportPowder';
  summary?: string;
  disableExpansion?: boolean;
}

const ExpansionPanel: React.FC<ExpansionPanelProps> = ({
  classes,
  children,
  color,
  summary,
  disableExpansion,
  ...rest
}) => (
  <MuiExpansionPanel
    classes={{
      expanded: classes.panelExpanded,
    }}
    {...rest}
  >
    {summary && (
      <ExpansionPanelSummary
        classes={{
          root: classnames(classes.panelSummaryRoot, {
            [classes.colorSupportPowder]: color === 'supportPowder',
          }),
          content: classes.panelSummaryContent,
        }}
        expandIcon={disableExpansion ? null : <ExpandMoreIcon color="primary" />}
      >
        <Typography variant="h3W600F15" color="primary">
          {summary}
        </Typography>
      </ExpansionPanelSummary>
    )}
    {children}
  </MuiExpansionPanel>
);

export default withStyles(styles, { name: 'LumaExpansionPanel' })(ExpansionPanel);
